import { render } from "./DashboardingHeader.vue?vue&type=template&id=6966e88b&lang=pug"
import script from "./DashboardingHeader.vue?vue&type=script&lang=js"
export * from "./DashboardingHeader.vue?vue&type=script&lang=js"

import "./DashboardingHeader.vue?vue&type=style&index=0&id=6966e88b&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__